import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Debug: show whether env vars were picked up (presence only — not the actual key)
// Remove this log after you verify the vars are loaded.
// eslint-disable-next-line no-console
// Show whether the important env vars are present. This helps diagnose
// why Firebase might not initialize in dev. Remove these logs after verifying.
// eslint-disable-next-line no-console

let app = null;
let auth = null;
let db = null;

try {
  if (!firebaseConfig.apiKey)
    throw new Error("Missing REACT_APP_FIREBASE_API_KEY");
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getDatabase(app);
} catch (err) {
  // Fail gracefully in dev when env isn't configured or key is invalid.
  // This prevents the whole app from crashing; pages using the DB should
  // check exported `db`/`auth` before calling SDK methods.
  // Log the error for developer visibility.
  // eslint-disable-next-line no-console
  console.warn(
    "Firebase initialization failed:",
    err && err.message ? err.message : err
  );
}

export { auth, db };
export default app;
